module.exports = __webpack_public_path__ + "img/img1.39556241.jpg";